export default "select K.a,K.b from (select H.b from (select G.c from (select F.d from\n(select E.e from A, B, C, D, E), F), G), H), I, J, K order by 1,2;\n"